export const getGridsSelections = (state) => state.grids.selection;
